import type { VehicleId } from '../../types/gcs/vehicle';
import type { GcsData } from '../../types/gcs/gcsData';

/**
 * Selector to determine if a vehicle is running in simulation mode
 *
 * @param data - The GCS data map from the store
 * @param gcsId - The GCS ID
 * @param vehicleId - The vehicle ID
 * @returns true if the vehicle state is marked as simulated
 */
export function selectIsVehicleSimulated(data: Map<string, GcsData>, gcsId: string, vehicleId: VehicleId): boolean {
  const gcsData = data.get(gcsId);
  if (!gcsData) return false;

  const vehicleState = gcsData.vehicleStateMap.get(vehicleId);
  return vehicleState?.isSimulated ?? false;
}
